import { Injectable } from '@angular/core';
import { IFilterListService } from './ifilter-list.service';
import { map } from 'rxjs';
import { Selectable } from 'src/app/shared/models/types/selectable.type';
import { DatabaseQueries } from 'src/app/models/shared/enums/get-query';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { WrapperResultGraphQL } from 'src/app/models/shared/types/wrapper-result-graphql.type';
import { PageInfo } from 'src/app/models/shared/types/page-info.type';
import { Team } from 'src/app/components/company/models/team.type';


@Injectable({
  providedIn: 'root'
})
export class TeamFilterService extends IFilterListService<Team> {
  pageInfo: PageInfo = { hasPreviusPage: false, hasNextPage: false, startCursor: null, endCursor: null };

  search(searchText: string, variables, isFirst: boolean): void {
    if (searchText) this.pageInfo = { ...this.pageInfo, endCursor: null, startCursor: null };

    this.graphQlService.getData<Team>(DatabaseQueries.GET_TEAMS_NO_IDS, { search: searchText, companyId: this.appService.companyId, first: variables.first, after: this.pageInfo.endCursor })
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        map(res => res['data']['teams'])
      )
      .subscribe({
        next: (res: WrapperResultGraphQL<Team>) => {
          let datasource: Array<Selectable<Team>> = [];
          if (this.pageInfo.endCursor) {
            const actualValue = this.datasource.getValue();
            datasource = [...actualValue, ...res.nodes.map(el => ({ ...el, displayId: el.id!, displayName: el.name, disabled: false, selected: false }))];
          } else {
            datasource = res.nodes.map(el => ({ ...el, displayId: el.id!, displayName: el.name, disabled: false, selected: false }));
          }

          this.pageInfo = res.pageInfo;
          this.datasource.next(datasource);
        }
      })
  }
}
